import { render, staticRenderFns } from "./MinhaResposta.vue?vue&type=template&id=7cffa5f8"
import script from "./MinhaResposta.vue?vue&type=script&lang=js"
export * from "./MinhaResposta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports